import {
  computed,
  defineComponent,
  reactive,
  toRefs,
  Ref,
  onMounted,
  ref,
  PropType,
  watch,
  nextTick,
} from "vue";
import { generateUuid, calcTotalPrice } from "@/utils";
import { columns } from "./work-package-table.constant";
import { WorkPackageTableRecord } from "./work-package-table.interface";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import _ from "lodash";
import { WorkPackageSelect } from "@/components";
import checkRight from "@/assets/images/check-right.png";
import checkRightGreen from "@/assets/images/check-right-green.png";
import { IsZhiHuiXingHe } from "@/core/hooks/SetTheme";
interface IState {
  // records: QuantityRecord[];
  selectedUuids: string[];
}

export default defineComponent({
  name: "WorkPackageTable",
  components: { WorkPackageSelect },
  props: {
    value: { type: Array as PropType<WorkPackageTableRecord[]>, default: [] },
  },
  emits: ["update:value", "totalChange"],
  setup(props, { emit }) {
    const state = reactive<any>({
      records: [new WorkPackageTableRecord()],
      selectedUuids: [],
    });
    const tableWrappers = ref();
    onMountedOrActivated(async () => {
      // console.log(props, "props**************************");
      // state.records = props.value;
      state.records = _.cloneDeep(props.value);

      // console.log(state.records, "state.records**************************");
    });
    watch(
      () => props.value,
      (newVal, oldVal) => {
        state.records = _.cloneDeep(newVal);
        state.records=state.records.filter(item=>item.workPackagesId
        )
        // console.log("🚀 ~ file: work-package-table.controller.ts:52 ~ setup ~  state.records:",  state.records)

        nextTick(() => {
          tableWrappers.value && tableWrappers.value?.reloadData();
          // // console.log(state.records, "props.value**************************",tableWrappers.value,tableWrappers.value?.xTable1.value);
        });
      },
      {
        deep: true,
        immediate:true
      }
    );
    const onSelectionChange = (keys: string[]) => {
      state.selectedUuids = keys;
    };

    const addRow = () => {
      const row = new WorkPackageTableRecord();
      row.merge({ uuid: generateUuid(), sortValue: 1 });
      // console.log(row);

      //   state.records.push(row);

      state.records = [row, ...state.records];
      state.records.map((item, index) => {
        item["sortValue"] = index + 1;
      });
    };
    const deleteRows = async () => {
      state.records = state.records.filter((item) => {
        return !state.selectedUuids.includes(item.uuid);
      });
      state.records.map((item, index) => {
        item["sortValue"] = index + 1;
      });
      state.selectedUuids = [];
    };
    const workPackageChange = (e, record) => {
      record.workPackagesName = e?.name;
      record.remark = e?.remark;
      record.isPhotograph = e?.isPhotograph;
      record.isExplain = e?.isExplain;
    };

    const moveTask = (row, type) => {
      switch (type) {
        case "p": //上移
          let s1 = row["sortValue"];
          let item1 = state.records.find((r) => r.sortValue == (s1 - 1));
          item1["sortValue"] = s1;
          row["sortValue"] = s1 - 1;
          break;
        case "n": //下移
          let s = row["sortValue"];
          let item = state.records.find((r) => r.sortValue == (s + 1));
          item["sortValue"] = s;
          row["sortValue"] = s + 1;
          break;

        case "t": //置顶
          row["sortValue"] = 0;
          break;

        case "b": //置底
          row["sortValue"] = state.records.length + 1;
          break;

        default:
          break;
      }
      state.records.sort((a, b) => a.sortValue - b.sortValue);
      state.records.map((item, index) => {
        item["sortValue"] = index + 1;
      });
      tableWrappers.value?.reloadData();
    };

    return {
      ...toRefs(state),
      columns,
      onSelectionChange,
      addRow,
      deleteRows,
      workPackageChange,
      tableWrappers,
      checkRight,
      checkRightGreen,
      isZHXH: IsZhiHuiXingHe(),
      moveTask,
    };
  },
});
